type StructureGenerationInput = {
  markdown: string;
  verifyCompliance?: boolean;
};

type RouteTemplateGenerationParams = StructureGenerationInput & {
  activeTab: string;
  forceStructure: boolean;
  generateStructureThenExample: (input: StructureGenerationInput) => Promise<void>;
  generateExampleThenStructure: (input: { markdown: string }) => Promise<void>;
};

export const createStructureGenerationInput = ({
  markdown,
  verifyCompliance,
}: StructureGenerationInput): StructureGenerationInput => ({
  markdown,
  verifyCompliance,
});

export const routeTemplateGeneration = async ({
  activeTab,
  forceStructure,
  markdown,
  verifyCompliance,
  generateStructureThenExample,
  generateExampleThenStructure,
}: RouteTemplateGenerationParams): Promise<void> => {
  if (forceStructure || activeTab === 'structure') {
    await generateStructureThenExample(
      createStructureGenerationInput({ markdown, verifyCompliance })
    );
    return;
  }

  await generateExampleThenStructure({ markdown });
};
